module.exports = __webpack_public_path__ + "media/images/icons/person-heart-3bd4b84395741974c28417c1e5cf29f0.svg";